import localForage from 'localforage';
import VuexPersistence from 'vuex-persist';

// Key lưu giá trị trong IndexDB
export const KEY_DB_NAME = 'MISA-InvoiceBots';
export const KEY_STORE_NAME = 'MISA-InvoiceBots-Store';
export const KEY_APP = 'MISA-InvoiceBots-App';

//Cấu hình thông tin
localForage.config({
	driver: [localForage.INDEXEDDB, localForage.WEBSQL, localForage.LOCALSTORAGE],
	name: KEY_DB_NAME,
	storeName: KEY_STORE_NAME,
	version: 1.0
});

/*Khởi tạo instance của VuexPersistance*/
const vuexPersistence = new VuexPersistence({
	key: KEY_APP,
	storage: localForage, //window.localStorage,
	asyncStorage: true, //false
	// Exclude module navigation khỏi IndexedDB — module này là ephemeral (tạm thời)
	// Sau khi F5 reload, bangKeNavigation luôn là null
	reducer: state => {
		const persistedState = Object.assign({}, state);
		delete persistedState.navigation;
		return persistedState;
	}
});

//Trả về plugin của vuex persistance
export const createVuexPersistance = () => {
	return vuexPersistence.plugin;
};

// Xóa dữ liệu của store trong storage
export const removeStorage = async () => {
	localStorage.removeItem(KEY_APP);
	await localForage.clear();
	localStorage.removeItem('ShowAgreement');
	localStorage.removeItem('ShowOrderNoYet');
	localStorage.removeItem('KeySortScreen');
	localStorage.removeItem('NotificationsInbot');
	//localStorage.removeItem('culture');
	localStorage.removeItem('FilterCache');
};
